module.exports = __webpack_public_path__ + "img/video.dc82c217.png";